import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-schedule-campaign-modal',
  templateUrl: './schedule-campaign-modal.component.html',
  styleUrls: ['./schedule-campaign-modal.component.scss'],
})
export class ScheduleCampaignModalComponent implements OnInit {
  @Input() scheduleData: any;
  tableData: { day: string; start: string | null; end: string | null }[] = [];

  constructor(public activeModal: NgbActiveModal, private translate: TranslateService) {}

  ngOnInit(): void {
    this.processScheduleData();
  }

  processScheduleData(): void {
    const days = [
      { key: 'monday', label: this.translate.instant('DAYS.MONDAY') },
      { key: 'tuesday', label: this.translate.instant('DAYS.TUESDAY') },
      { key: 'wednesday', label: this.translate.instant('DAYS.WEDNESDAY') },
      { key: 'thursday', label: this.translate.instant('DAYS.THURSDAY') },
      { key: 'friday', label: this.translate.instant('DAYS.FRIDAY') },
      { key: 'saturday', label: this.translate.instant('DAYS.SATURDAY') },
      { key: 'sunday', label: this.translate.instant('DAYS.SUNDAY') },
    ];

    this.tableData = days.map(day => {
      const isActive = this.scheduleData.data[0][`${day.key}_active`] === 1;
      return {
        day: day.label,
        start: isActive ? this.scheduleData.data[0][`${day.key}_start`] : null,
        end: isActive ? this.scheduleData.data[0][`${day.key}_end`] : null,
      };
    });
  }

  closeModal(): void {
    this.activeModal.dismiss();
  }
}
